import React from 'react';
import { defaultTemplate } from 'core/hoc';
import { translate } from 'core/utils';
import { fulfillmentOrderAction } from 'common/constants';
import getResponseColor from 'core/utils/getResponseColor';

function ResultReportTemplate({ resultReportViewStore: { data, fulfillmentOrderAction }, t }) {
	return (
		<section>
			<div className="ReactModal__header">
				<h2 className="spc--bottom--sml">{t('RESULTREPORTVIEW.RESULTREPORT')}</h2>
			</div>
			<div className="ReactModal__body">{data && <DisplayData data={data} foAction={fulfillmentOrderAction} />}</div>
			<div className="ReactModal__footer"></div>
		</section>
	);
}

const DisplayData = ({ data, foAction }) => {
	switch (foAction) {
		case fulfillmentOrderAction.BulkCancel:
			return <BulkCancel data={data} />;
		case fulfillmentOrderAction.LabelPullOnPickingBatchCreate:
			return <LabelPullOnPickingBatchCreate data={data} />;
		case fulfillmentOrderAction.BulkAssignCarrierAccount:
			return <BulkAssignCarrierAccount data={data} />;
		default:
			return <JsonViewer data={data} />;
	}
};

const BulkCancel = ({ data }) => {
	return (
		<div className="result-report">
			<ul className="result-report__array">
				{data.map((item, index) => (
					<li key={index} className="result-report__array-item" style={{backgroundColor: getResponseColor(item.status)}}>
						<ul className="result-report__object">
							<li>
								<strong>{translate('RESULTREPORTVIEW.RESPONSEDATA.BULKCANCEL.MESSAGE')}:</strong>{' '}
								{translate(item.result)}
							</li>
							{item.fulfillmentOrderIds && item.fulfillmentOrderIds.length > 0 && (
								<li>
									<strong>{translate('RESULTREPORTVIEW.RESPONSEDATA.BULKCANCEL.FULFILLMENTORDERIDS')}:</strong>{' '}
									{item.fulfillmentOrderIds.join(', ')}
								</li>
							)}
						</ul>
					</li>
				))}
			</ul>
		</div>
	);
};

const BulkAssignCarrierAccount = ({ data }) => {
	return (
		<div className="result-report">
			<ul className="result-report__array">
				{data.map((item, index) => (
					<li key={index} className="result-report__array-item" style={{backgroundColor: getResponseColor(item.status)}}>
						<ul className="result-report__object">
							<li>
								<strong>{translate('RESULTREPORTVIEW.RESPONSEDATA.BULKCANCEL.MESSAGE')}:</strong>{' '}
								{translate(item.message)}
							</li>
							{item.fulfillmentOrderIds && item.fulfillmentOrderIds.length > 0 && (
								<li>
									<strong>{translate('RESULTREPORTVIEW.RESPONSEDATA.BULKCANCEL.FULFILLMENTORDERIDS')}:</strong>{' '}
									{item.fulfillmentOrderIds.join(', ')}
								</li>
							)}
						</ul>
					</li>
				))}
			</ul>
		</div>
	);
};

const LabelPullOnPickingBatchCreate = ({ data }) => {
    return (
        <div className="result-report">
            {/* Summary Section */}
            <ul className="result-report__array">
                <li className="result-report__array-item" style={{ backgroundColor: '#e2e3e5' }}>
                    <ul className="result-report__object">
                        <li><strong>Total:</strong> {data.total}</li>
                        <li><strong>Success:</strong> {data.success}</li>
                    </ul>
                </li>
            </ul>

            {/* Error Details Section */}
            <ul className="result-report__array">
                {data && data.errors && data.errors.map((error, index) => (
                    <li key={index} className="result-report__array-item" style={{ backgroundColor: '#f8d7da' }}>
                        <ul className="result-report__object">
                            <li>
                                {error}
                            </li>
                        </ul>
                    </li>
                ))}
            </ul>
        </div>
    );
};

const JsonViewer = ({ data }) => {
	const renderJson = value => {
		if (Array.isArray(value)) {
			return (
				<ul className="result-report__array">
					{value.map((item, index) => (
						<li key={index} className="result-report__array-item">
							{renderJson(item)}
						</li>
					))}
				</ul>
			);
		} else if (value !== null && typeof value === 'object') {
			return (
				<ul className="result-report__object">
					{Object.entries(value).map(([key, val]) => (
						<li key={key}>
							<strong>{key}:</strong> {renderJson(val)}
						</li>
					))}
				</ul>
			);
		} else {
			if (value === null || value === undefined || value === '') {
				return <span className="result-report__null">null</span>;
			}

			if (typeof value === 'boolean') {
				return <span className="result-report__boolean">{value ? 'Yes' : 'No'}</span>;
			}

			return <span>{translate(String(value))}</span>;
		}
	};

	return <div className="result-report">{renderJson(data)}</div>;
};

export default defaultTemplate(ResultReportTemplate);
